export default __webpack_public_path__ + "static/media/filter-white.69033167.svg";